import { sortBy } from 'lodash'

import { FilterField } from '@/components/UI/Filter/utils/types'
import { FilterComparison } from '@/components/UI/Filter/utils/enums'

import { LINKED_TRANSACTION_FIELDS } from './const'
import { FILTER_OPTION_LINKED_DATA_TRANSACTIONS, FILTER_OPTION_RESOURCE } from '@/services/filters/utils/const'

import useFiltersService from '@/services/filters'

export const getLinkedDataTransactionsFilters = (additionalFields?: FilterField[]): FilterField[] => {
  const { fetchOptions } = useFiltersService()

  return sortBy(
    [
      {
        name: LINKED_TRANSACTION_FIELDS.ACCESS_METHOD.field,
        caption: LINKED_TRANSACTION_FIELDS.ACCESS_METHOD.label,
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.ACCESS_METHOD,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELDS.ACCOUNT_NAME.field,
        caption: LINKED_TRANSACTION_FIELDS.ACCOUNT_NAME.label,
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.ACCOUNT_NAME,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELDS.ACCOUNT_NUMBER.field,
        caption: LINKED_TRANSACTION_FIELDS.ACCOUNT_NUMBER.label,
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.ACCOUNT_NUMBER,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELDS.ACCOUNT_TYPE.field,
        caption: LINKED_TRANSACTION_FIELDS.ACCOUNT_TYPE.label,
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.ACCOUNT_TYPE,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELDS.AMOUNT.field,
        caption: LINKED_TRANSACTION_FIELDS.AMOUNT.label,
        isAmount: true,
      },
      {
        name: LINKED_TRANSACTION_FIELDS.CATEGORY.field,
        caption: LINKED_TRANSACTION_FIELDS.CATEGORY.label,
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.CATEGORY,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELDS.CONNECTOR_NAME.field,
        caption: LINKED_TRANSACTION_FIELDS.CONNECTOR_NAME.label,
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.CUSTODIAN,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELDS.COUNTERPARTY.field,
        caption: LINKED_TRANSACTION_FIELDS.COUNTERPARTY.label,
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.COUNTERPARTY,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELDS.DATE.field,
        caption: LINKED_TRANSACTION_FIELDS.DATE.label,
        isDate: true,
      },
      {
        name: LINKED_TRANSACTION_FIELDS.OVERRIDE_DATE.field,
        caption: LINKED_TRANSACTION_FIELDS.OVERRIDE_DATE.label,
        isDate: true,
      },
      {
        name: LINKED_TRANSACTION_FIELDS.DESCRIPTION.field,
        caption: LINKED_TRANSACTION_FIELDS.DESCRIPTION.label,
      },
      {
        name: LINKED_TRANSACTION_FIELDS.MONTH.field,
        caption: LINKED_TRANSACTION_FIELDS.MONTH.label,
        isMonth: true,
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.MONTH,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELDS.QUARTER.field,
        caption: LINKED_TRANSACTION_FIELDS.QUARTER.label,
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.QUARTER,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELDS.SUBCATEGORY.field,
        caption: LINKED_TRANSACTION_FIELDS.SUBCATEGORY.label,
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.SUBCATEGORY,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELDS.TAGS.field,
        caption: LINKED_TRANSACTION_FIELDS.TAGS.label,
        defaultComparison: FilterComparison.CONTAINS,
        comparison: [FilterComparison.CONTAINS, FilterComparison.NOTCONTAINS],
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.TAGS,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELDS.TYPE.field,
        caption: LINKED_TRANSACTION_FIELDS.TYPE.label,
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.TYPE,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELDS.YEAR.field,
        caption: LINKED_TRANSACTION_FIELDS.YEAR.label,
        isSimple: true,
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.YEAR,
        ),
      },
      {
        name: LINKED_TRANSACTION_FIELDS.STATUS.field,
        caption: LINKED_TRANSACTION_FIELDS.STATUS.label,
        defaultComparison: FilterComparison.EQ,
        comparison: [FilterComparison.EQ, FilterComparison.NOTEQ],
        getter: () => fetchOptions(
          FILTER_OPTION_RESOURCE.LINKED_DATA_TRANSACTIONS,
          FILTER_OPTION_LINKED_DATA_TRANSACTIONS.STATUS,
        ),
      },
      ...(additionalFields || []),
    ],
    'caption',
  )
}
